import requests from "./httpService";

const EmployeeTrackService = {
     getAllEmployeeTrack: async () =>{
        return requests.get("/employee-track/all");
     },
     getEmployeeTrackById: async (id, body) =>{
        return requests.get(`/employee-track/${id}`, body);
     },
     UpdateEmployeeTrackById: async (id, body) =>{
        return requests.put(`/employee-track/${id}`, body);
     },
     addEmployeeTrack: async (body) =>{
        return requests.post("/employee-track/add", body);
     },
     deleteEmployeeTrackById: async (id) =>{
        return requests.delete(`/employee-track/${id}`);
     }
}

export default EmployeeTrackService;